<!-- ********************WEB VIEW******************** -->

<!-- Premiere Card web-view -->
<script src="lineup-card.component.ts"></script>
<div class="divLineup" style="background-color: white">
  <span>
    <img class="image" src="{{ premiere.mobilethumbimage }}" />
  </span>

  <h3 class="spotlightsDate">
    {{
      premiere.cinejoySpotlightsSchedule[0]?.scheduleTimeText
        | date : "EEE, MMMM d, y, h:mm:ss a"
    }}
    {{ timezone }}
  </h3>

  <h3 class="spotLightsTitle">{{ premiere.name }}</h3>

  <a
    *ngIf="!archive"
    class="spotLightsTitle"
    style="font-size: 14px"
    [href]="groupshareUrl"
    target="_blank"
    appTrackClick
    [buttonProps]="{
      title:'spotlight_experience_with_group',
      customeId:premiere.eventId,
      feature_context:'CINEJOY'
       }"
    >Experience Spotlight with Group</a
  >
  <div class="spotlight_button" *ngIf="!archive">
    <button
      id="btn1"
      (click)="open(premiere.eventId, premiere, 'Buy')"
      *ngIf="!isBuyButtonActive"
      appTrackClick
      [buttonProps]="{
        title:'spotlight_buy',
        customeId:premiere.eventId,
        feature_context:'CINEJOY'
    }"
    >
      {{bulkPurchaseEnabled?'Buy One Tix':'Buy'}}
    </button>
    <button
      id="btn5"
      (click)="initiateBulkPurchase(premiere.eventId)"
      *ngIf="bulkPurchaseEnabled&& !isBuyButtonActive"
      appTrackClick
      [buttonProps]="{
        title:'spotlight_buy_bulk',
        customeId:premiere.eventId,
        feature_context:'CINEJOY'
    }"
    >
      Buy Bulk Tix
    </button>
    <button id="btn2" (click)="redirect()" [disabled]="joinButtonDisabled">
      Join
    </button>
    <button id="btn3" (click)="gotoMoreInfo(premiere.eventId, premierename, premiere.type)"
    appTrackClick
      [buttonProps]="{
        title:'spotlight_more_info',
        customeId:premiere.eventId,
        feature_context:'CINEJOY'
    }">
      More Info
    </button>

    <button *ngIf="!premiere.bookmarked" 
      style="border: none; background-color: white;"
      (click)="bookmarkEvent(premiere.eventId, true)"
      appTrackClick
      [buttonProps]="{
        title:'spotlight_bookMark',
        customeId:premiere.eventId,
        feature_context:'CINEJOY'
    }"
      >
      <img src="../../../../../assets/images/pass.png" alt="Bookmark Image" width="40px" height="37.5px" />
    </button>

    <button *ngIf="premiere.bookmarked" 
      style="border: none; background-color: white;"
      (click)="alreadyBookmarkEvent(true)">
      <img src="../../../../../assets/images/Bookmarked.png" alt="Bookmark Image" width="40px" height="37.5px" />
    </button>

    <button id="btn4" (click)="openDialog(premiere)" *ngIf="isBuyButtonActive && createGroup ">
           <ng-container *ngIf="!exsistingGroup">
      Create Group
    </ng-container>
           <ng-container *ngIf="exsistingGroup">Manage Group</ng-container>
        </button>
  </div>

  <div
    class="spotlight_button"
    style="text-align: center !important; margin-left: 0 !important"
    fxLayoutGap="10px"
    *ngIf="archive"
  >
    <button id="btn3" (click)="gotoMoreInfo(premiere.eventId, premierename,premiere.type)">
      More Info
    </button>
  </div>
</div>

<!-- Premiere Card web-view Ended -->

<!-- ********************WEB VIEW ENDED******************** -->
